/**
 * Return an immutable, position-normalized stage order.
 * Returns null when the requested move is not valid.
 */
export const movePipelineColumn = (columns, columnId, targetIndex) => {
  const sourceIndex = columns.findIndex(column => column.id === columnId);
  if (
    sourceIndex === -1 ||
    targetIndex < 0 ||
    targetIndex >= columns.length ||
    sourceIndex === targetIndex
  ) {
    return null;
  }

  const reordered = columns.map(column => ({ ...column }));
  const [movedColumn] = reordered.splice(sourceIndex, 1);
  reordered.splice(targetIndex, 0, movedColumn);

  return reordered.map((column, position) => ({ ...column, position }));
};
